import {Card} from 'platform/components';

import {isNil} from 'ramda';

import {suffixTestId, TestIdProps} from 'shared/web';

import {usePriceReport} from '../../../hooks/usePriceReport';
import i18n from '../../../i18n/i18n';
import {DrillDownLevelName, DrillDownStatisticsLevel} from '../../../types/api/drillDown';
import {DrillDown} from '../../DrillDown/components/DrillDown/DrillDown';

interface CreateDrillDownProps extends TestIdProps {
  filters: Partial<Record<DrillDownLevelName, string>>;
  onRowSelect: (levels: DrillDownStatisticsLevel[]) => void;
}

export function DrillDownPicker(props: CreateDrillDownProps) {
  const {requestData} = usePriceReport();
  const market = requestData?.market;
  const hiddenLevels: DrillDownLevelName[] = [
    'make',
    'model_family_group',
    'model',
    'mileage_range',
  ];
  const initialLevelOrder: DrillDownLevelName[] = [
    'make',
    'model_family_group',
    'model',
    'year',
    'fuel_type',
    'transmission',
    'drive',
    'power',
    'car_style',
    'mileage_range',
  ];
  const permanentFilters = {
    make: props.filters.make,
    model: props.filters.model,
  };
  const selectedRow = {
    make: props.filters.make,
    model_family_group: undefined,
    model: props.filters.model,
    year: props.filters.year,
    fuel_type: props.filters.fuel_type,
    transmission: props.filters.transmission,
    drive: props.filters.drive,
    power: props.filters.power,
    car_style: props.filters.car_style,
    mileage_range: undefined,
  };

  if (isNil(market)) {
    return null;
  }

  return (
    <Card
      title={i18n.t('page.create.labels.createDrillDown')}
      variant="inlineGrey"
      isExpandable
      isClosedByDefault
    >
      <DrillDown
        regions={[market]}
        currency="CZK" // We don't know currency, but we are not going to use prices
        hiddenLevels={hiddenLevels}
        initialLevelOrder={initialLevelOrder}
        permanentFilters={permanentFilters}
        selectedRow={selectedRow}
        boldFontForSelectedRowOnly
        hideConfigurator
        isSimplified
        onSelect={props.onRowSelect}
        data-testid={suffixTestId('createDrillDown', props)}
      />
    </Card>
  );
}
